import styled from 'styled-components';
import { fontSnippets } from '@/styles/template';

const starSize = 2;

export const Wrap = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  gap: 2rem;
`;

export const RatingNumber = styled.div`
  ${fontSnippets.BS};
  font-size: ${starSize}rem;
  line-height: ${starSize}rem;
  height: ${starSize}rem;
  padding-top: ${starSize}px;
`;

export const StarWrapper = styled.div`
  display: inline-block;
  width: ${starSize}rem;
  height: ${starSize}rem;
  position: relative;
`;